/**
 * Resuelve la marca de un producto de Posición coalesciendo POR PRODUCTO:
 *   tag_MARCA (si no está vacío) → Marca nativa → marca
 *
 * Antes se usaba un flag global all-or-nothing (`hasTagMarca`): si CUALQUIER
 * producto tenía tag_MARCA, todo el dataset se resolvía por tag_MARCA. Los
 * productos con tag_MARCA null/'' (p.ej. sitios sin tags como "Dash deportes")
 * quedaban con marca '' y se descartaban del reporte → "No se encontraron
 * marcas", aunque la columna Marca nativa estuviera poblada (bug PT-#39).
 */
export function getProductBrand(product: any): string {
  const tag = product?.tag_MARCA;
  if (typeof tag === 'string' && tag.trim() !== '') return tag.trim();

  const native = product?.Marca ?? product?.marca;
  if (typeof native === 'string' && native.trim() !== '') return native.trim();
  if (native != null && native !== '') return String(native).trim();

  return '';
}
